<template>
  <div class="text-field-wrap gr-icon">
    <img v-if="icon" :src="icon" :width="widthIcon" />
    <span
      class="text-field ellipsis"
      v-lego-tooltip="{ arg: overLineClamp ? '' : 'ellipsis', value: value, isShowHTML: isHtml }"
    >
      <em v-if="value && isHtml" v-html="value"></em>
      <em v-else-if="value && !isHtml">{{ value }}</em>
      <c-nodata v-else></c-nodata>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextBox',
  props: {
    value: {
      type: String,
      default: ''
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    withoutPointer: {
      type: Boolean,
      default: false
    },
    textLineClamp: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    widthIcon: {
      type: String,
      default: ''
    },
    overLineClamp: {
      type: Boolean,
      default: false
    },
    isHtml: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEllipsis: false,
      multiline: false
    };
  },
  computed: {
    // returnWhiteSpace() {
    //   return this.value ? this.value.includes(' ') : false;
    // }
  },
  created() {},
  mounted() {},
  methods: {
    getEllipsisState(e) {
      const MAX_WIDTH = 239;
      if (this.tooltip) {
        if (!this.withoutPointer) {
          this.$refs.tooltipElement.style.cursor = 'pointer';
        }
        this.isEllipsis = e.target.offsetWidth > MAX_WIDTH ? true : false;
      }
      if (this.isEllipsis) {
        this.multiline = true;
        this.$nextTick(() => {
          const element = e.target.getBoundingClientRect();
          this.$refs.tooltipContent.style.whiteSpace = 'normal';
          this.$refs.tooltipContent.style.top = element.top + element.height + 15 + 'px';
          this.$refs.tooltipContent.style.left = element.left + element.width / 2 + 'px';
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gr-icon {
  display: flex;
  align-items: center;

  img {
    margin-right: 5px;
  }
}
.text-field-wrap {
  // position: relative;
  padding: 8px 0 0;
  min-height: 20px;
  max-height: 40px;
  line-height: 1;

  .text-field {
    display: inline-block;
    min-width: 100px;
    max-width: 240px;
    color: #2f3237;
    font-family: $lego__font-family;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 20px;

    & em {
      display: block;
      font-style: normal;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .text-line-clamp {
    & em {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }

  .field-tooltip {
    position: fixed;
    display: inline-flex;
    width: auto;
    min-width: 100px;
    color: #fff;
    padding: 6px 10px;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    background-color: #1f2533;
    box-sizing: border-box;
    transform: translateX(-50%);
    z-index: 1;
    max-width: 292px;
    word-break: break-word;

    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      top: -6px;
      left: 50%;
      width: 0;
      height: 0;
      border-top: 6px solid #1f2533;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      transform: rotate(180deg);
    }
  }
}
</style>
